import { assert } from './assert'

const supportedAudioMimeTypes = ['audio/webm;codecs=opus', 'audio/ogg;codecs=opus', 'audio/mp4', 'audio/wav']

export function audioMimeTypeToFileExtension(mimeType: string): string {
  const baseMimeType = mimeType.split(';')[0]

  // This covers the most common audio MIME types
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/MIME_types/Common_types
  if (baseMimeType === 'audio/webm') {
    return 'webm'
  } else if (baseMimeType === 'audio/ogg') {
    return 'oga'
  } else if (baseMimeType === 'audio/mp4') {
    return 'mp4'
  } else if (baseMimeType === 'audio/wav') {
    return 'wav'
  } else if (baseMimeType === 'audio/aac') {
    return 'aac'
  } else if (baseMimeType === 'audio/mp3' || baseMimeType === 'audio/mpeg') {
    return 'mp3'
  } else if (baseMimeType === 'audio/mpeg') {
    return 'mpeg'
  } else if (baseMimeType === 'audio/ogg;codecs=opus') {
    return 'ogg'
  }

  assert(false, `Unsupported MIME type: ${mimeType}`)
}

export function defaultMimeType(): string | undefined {
  return supportedAudioMimeTypes.find((type) => MediaRecorder.isTypeSupported(type))
}
